import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ICheckboxProps {
  name: string;
  id: string;
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
  dataTestId?: string;
}

const Checkbox = ({
  name,
  id,
  checked,
  disabled,
  onChange,
  dataTestId,
}: ICheckboxProps) => {
  const labelClassName = twMerge(
    'prose-body-sm-reg',
    'block',
    'text-kira-slate-900',
    disabled && 'text-kira-slate-700 opacity-50'
  );

  return (
    <label key={id} htmlFor={id} className={labelClassName}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        className="-mt-0.5 mr-2 h-4 w-4 border-2 border-kira-slate-700 checked:text-kira-blue-800 focus:ring-kira-blue-800"
        data-testid={dataTestId}
      />
      {name}
    </label>
  );
};

export default Checkbox;
